import { useMemo } from 'react';

/**
 * Encapsulates messages filtering and derived tag list so <AdminMessages/>
 * stays focused on rendering + actions. Pure function — safe to memoize.
 *
 * @param {Array} messages
 * @param {{ statusFilter: string, tagFilter: string, q: string }} filters
 */
export function useMessageFilters(messages, { statusFilter, tagFilter, q }) {
  const allTags = useMemo(() => {
    const set = new Set();
    messages.forEach((m) => (m.tags || []).forEach((t) => set.add(t)));
    return Array.from(set).sort();
  }, [messages]);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return messages.filter((m) => {
      if (statusFilter === 'Active' && m.archived) return false;
      if (statusFilter === 'Unread' && (m.status !== 'New' || m.archived)) return false;
      if (statusFilter === 'Read' && (m.status !== 'Read' || m.archived)) return false;
      if (statusFilter === 'Archived' && !m.archived) return false;
      if (tagFilter && !(m.tags || []).includes(tagFilter)) return false;
      if (!term) return true;
      return (
        m.name?.toLowerCase().includes(term) ||
        m.email?.toLowerCase().includes(term) ||
        m.message?.toLowerCase().includes(term) ||
        m.interest?.toLowerCase().includes(term) ||
        (m.tags || []).some((t) => t.toLowerCase().includes(term))
      );
    });
  }, [messages, q, statusFilter, tagFilter]);

  return { allTags, filtered };
}
